/*
  Kelly & Windsor Variant Content Switcher
  -----------------------------------------
  Shows/hides variant-specific content blocks and updates the selected
  variant title as the shopper changes size/warmth/etc on the product page.

  Mark any variant-specific content with:
    data-variant-content
    data-variant-id="{{ v.id }}"

  DEPENDENCY
  Expects `window.productVariants` (the product's variants array, e.g.
  from a script tag rendering {{ product.variants | json }}) to already
  be populated before this script runs.

  OPTIONAL MARKUP
  Add `data-main-product-form` to the buy-box form if a page can ever
  contain more than one /cart/add form (upsells, cart drawer, etc), to
  disambiguate which one this script should read from.
*/

(function () {
  'use strict';

  var CART_FORM_SELECTOR = 'form[action*="/cart/add"]';

  function getVariantById(variantId) {
    if (!variantId || !window.productVariants) return null;

    return window.productVariants.find(function (variant) {
      return String(variant.id) === String(variantId);
    }) || null;
  }

  // Reads ?variant=<id> from the URL, e.g. from a collection link.
  function getVariantIdFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant');

    return getVariantById(variantId) ? variantId : null;
  }

  function getMainProductForm() {
    return (
      document.querySelector('[data-main-product-form]') ||
      document.querySelector(CART_FORM_SELECTOR)
    );
  }

  // Reads the currently selected value for each option index (0, 1, 2...),
  // preferring a checked swatch radio and falling back to a
  // single-option-selector dropdown for that index. Stops once neither
  // control exists for a given index.
  function getSelectedOptionValues(form) {
    var values = [];
    var i = 0;

    while (true) {
      var swatchGroup = form.querySelector('.swatch[data-option-index="' + i + '"]');
      var checkedSwatch = swatchGroup && swatchGroup.querySelector('input[type="radio"]:checked');
      var select = form.querySelector('[data-option="option' + (i + 1) + '"]');

      if (checkedSwatch) {
        values.push(checkedSwatch.value);
      } else if (select) {
        values.push(select.value);
      } else {
        break;
      }
      i++;
    }

    return values;
  }

  // Matches an array of option values (e.g. ["Single", "Summer"]) against
  // window.productVariants to find the corresponding variant.
  function getVariantByOptionValues(values) {
    if (!values.length || !window.productVariants) return null;

    return window.productVariants.find(function (variant) {
      return (
        variant.options.length === values.length &&
        variant.options.every(function (opt, idx) {
          return String(opt).trim() === String(values[idx]).trim();
        })
      );
    }) || null;
  }

  function getVariantIdFromForm() {
    var form = getMainProductForm();
    if (!form) return null;

    var variant = getVariantByOptionValues(getSelectedOptionValues(form));
    if (variant) return String(variant.id);

    // Fallback for products without swatches or single-option-selectors
    // — read the hidden id field directly.
    var idInput = form.querySelector('input[name="id"], select[name="id"]');
    if (idInput && idInput.value && getVariantById(idInput.value)) {
      return idInput.value;
    }

    return null;
  }

  // URL variant takes priority (important for collection links using
  // ?variant=), then falls back to whatever's currently selected in the form.
  function getCurrentVariantId() {
    return getVariantIdFromForm() || getVariantIdFromUrl();
  }

  function showVariantContent(variantId) {
    document.querySelectorAll('[data-variant-content]').forEach(function (el) {
      var isActive = el.dataset.variantId === String(variantId);
      el.classList.toggle('is-active', isActive);
      el.toggleAttribute('hidden', !isActive);
      el.setAttribute('aria-hidden', String(!isActive));
    });
  }

  function updateSelectedVariantTitle(variantId) {
    var output = document.querySelector('[data-selected-variant-title]');
    var selectedVariant = getVariantById(variantId);

    if (!output || !selectedVariant) return;

    output.textContent = selectedVariant.options.join(' · ');
  }

  function updateProductVariantUI(variantId) {
    if (!variantId || !getVariantById(variantId)) return;

    showVariantContent(variantId);
    updateSelectedVariantTitle(variantId);
  }

  function syncCurrentVariant() {
    var variantId = getCurrentVariantId();
    if (variantId) updateProductVariantUI(variantId);
  }

  function init() {
    if (!window.productVariants || !Array.isArray(window.productVariants)) {
      console.warn(
        '[variant-content-switcher] window.productVariants is missing or not an array. ' +
        'Make sure the product JSON is rendered before this script runs.'
      );
      return;
    }

    var urlVariantId = getVariantIdFromUrl();

    if (urlVariantId) {
      updateProductVariantUI(urlVariantId);
    } else {
      syncCurrentVariant();
    }
  }

  document.addEventListener('DOMContentLoaded', init);

  // Swatch radios and single-option-selector dropdowns both dispatch a
  // native `change` event the instant the shopper makes a selection.
  document.addEventListener('change', function (event) {
    if (!event.target.closest(CART_FORM_SELECTOR)) return;
    syncCurrentVariant();
  });

  // Optional hook for themes that dispatch a custom variant-change event
  // on top of the native change event.
  document.addEventListener('variant:change', function (event) {
    if (event.detail && event.detail.variant && event.detail.variant.id) {
      updateProductVariantUI(event.detail.variant.id);
    }
  });

  // Browser back / forward through variant URLs.
  window.addEventListener('popstate', syncCurrentVariant);
})();